import React from 'react'
import { Box, Button, Typography, makeStyles } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import Link from './Link'
import ArrowIcon from './ArrowIcon'

const WrapperComponent = ({ link, children, ...props }) => {
  return link ? (
    <Link to={link} {...props}>
      {children}
    </Link>
  ) : (
    <Box {...props}>{children}</Box>
  )
}

const EndIconButton = ({
  link,
  title,
  icon,
  className,
  description,
  ...buttonProps
}) => {
  const { locale } = useIntl()
  const styles = useStyles()

  return (
    <WrapperComponent
      key="wrapper--end-icon-button"
      link={link}
      className={[className, styles.ctaWrapper]}
      style={buttonProps.style}
    >
      <Button
        {...buttonProps}
        className={styles.iconButton}
        variant="contained"
        color="secondary"
        {...(icon !== false && {
          endIcon: icon || <ArrowIcon direction={'forward'} locale={locale} />,
        })}
      >
        <Typography variant="body2" className={styles.buttonLabel}>
          {title || ''}
        </Typography>
      </Button>
      {description && (
        <Box className={styles.ctaDescription}>{description}</Box>
      )}
      <div id="recaptcha-container" className={styles.recaptchaContainer} />
    </WrapperComponent>
  )
}

const useStyles = makeStyles((theme) => ({
  ctaWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  iconButton: {
    width: '100%',
    padding: theme.spacing(1, 2.5),
    marginRight: theme.spacing(2),
    borderRadius: 2,
    minWidth: 'fit-content',
    '[lang=ar] &': {
      '&>span': {
        paddingBottom: 2,
      },
    },
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
      padding: theme.spacing(0.75, 2.5),
    },
  },
  buttonLabel: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: '1rem',
  },
  ctaDescription: {
    display: 'inline-flex',
    '&>p': {
      color: theme.palette.text.lightGrey,
      fontSize: '0.75rem',
      '&>a': {
        color: theme.palette.text.primary,
        textDecoration: 'none',
      },
    },
  },
  recaptchaContainer: {
    width: 0,
    height: 0,
    overflow: 'hidden',
  },
}))

export default EndIconButton
